import posthog from "posthog-js";

export default defineNuxtPlugin(() => {
  if (import.meta.dev) return {};

  posthog.init("phc_9wKzkjuUM47AMPoKHCEDBodTMxMjEqdJV20UQnPayJ0", {
    api_host: "https://j.contrat-ia.com",
    ui_host: "https://eu.posthog.com",
  });

  return {
    provide: {
      clientPosthog: posthog,
    },
  };
});
